import { ChangeEvent, useEffect, useState } from "react";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Box,
  Tooltip,
  IconButton,
} from "@mui/material";
import { useRagSources } from "../../hooks/useRagSources";
import InfoIcon from '@mui/icons-material/Info';

export type RagSourceMultiSelectProps = {
  onRagChange: (newRag: string[]) => void;
  currentRagValue: string[];
};

export default function RagSourceMultiSelect({
  onRagChange,
  currentRagValue,
}: RagSourceMultiSelectProps) {
  const [ragValue, setRagValue] = useState<string[]>(currentRagValue);
  const ragSources = useRagSources();

  const handleRagChange = (
    event: ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) => {
    const contentIndex = ragSources.ragSources.find(
      (rs) => rs.name === event.target.name,
    )?.content_index;
    if (contentIndex === undefined) return;
    setRagValue((prev) =>
      checked ? [...prev, contentIndex] : prev.filter((n) => n != contentIndex),
    );
  };

  useEffect(() => {
    onRagChange(ragValue);
  }, [ragValue]);

  if (!ragSources.ragSources || ragSources.ragSources.length < 1) return <></>;

  return (
    <FormControl component="fieldset" fullWidth>
      <FormGroup>
        {ragSources.ragSources.map((rs) => (
          <FormControlLabel
            key={rs.name}
            control={
              <Checkbox
                onChange={handleRagChange}
                name={rs.name}
                checked={ragValue.some((n) => n === rs.content_index)}
              />
            }
            label={rs.name}
          />
        ))}
      </FormGroup>
    </FormControl>
  );
}
